import * as v from "valibot";
import { rpcContract } from "../rpc";

export const getLiveEventByIdRpcContract = rpcContract({
  name: "get-live-event-by-id",
  paramsSchema: v.object({
    event_id: v.string(),
  }),
  resultSchema: v.object({
    event: v.nullable(
      v.object({
        id: v.string(),
        title: v.string(),
        description: v.nullable(v.string()),
        content_tier: v.string(),
        fee_cents: v.nullable(v.number()),
        status: v.string(),
        scheduled_start_time: v.nullable(v.string()),
        actual_start_time: v.nullable(v.string()),
        end_time: v.nullable(v.string()),
        max_attendees: v.nullable(v.number()),
        thumbnail_url: v.nullable(v.string()),
        thumbnail_file_id: v.nullable(v.string()),
        whatsapp_url: v.nullable(v.string()),
        post_buying_video_file_id: v.nullable(v.string()),
        post_buying_video_url: v.nullable(v.string()),
        cta_text: v.nullable(v.string()),
        language: v.optional(v.nullable(v.string())),
        stream_delivery: v.optional(v.string()),
        peak_viewer_count: v.number(),
        expected_duration: v.nullable(v.number()),
        created_at: v.string(),
        updated_at: v.string(),
        community_only: v.boolean(),
        community_ids: v.array(v.string()),
        linked_links: v.optional(
          v.array(
            v.object({
              id: v.string(),
              title: v.string(),
              has_discount: v.boolean(),
              code: v.nullable(v.string()),
              url: v.string(),
              event_only: v.boolean(),
            }),
          ),
        ),
        tickets_sold: v.optional(v.number()),
      }),
    ),
  }),
});

export type GetLiveEventByIdParams = v.InferOutput<(typeof getLiveEventByIdRpcContract)["paramsSchema"]>;
export type GetLiveEventByIdResult = v.InferOutput<(typeof getLiveEventByIdRpcContract)["resultSchema"]>;
